import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import React from "react";
import { ListStateIcon } from "../ListStateIcon/ListStateIcon";

interface IListStateIconNotificationProps {
    noMargin?: boolean;
    tooltip: string;
}

export const ListStateIconNotification = (props: IListStateIconNotificationProps) => {
    return (
        <ListStateIcon
            tooltip={props.tooltip}
            icon={NotificationsNoneIcon}
            noMargin={props.noMargin}
        />
    );
};
